module.exports = __webpack_public_path__ + "5c21e28e637aa7ed7a1380a7230bb684.svg";